import ApiService from '@/services/apiService/lambda';
import { mapState } from 'vuex';
import get from 'lodash/get';
import { cloneDeep } from 'lodash';
export default {
  name: 'CoreDtwinRuleEditConditionsNoMetrics',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      localRule: cloneDeep(this.rule)
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    }
  },
  watch: {
    rule: {
      handler(newVal) {
        this.localRule = cloneDeep(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.localRule.properties.conditionType = 'script';
  },
  methods: {
    onScriptEditorChange(updatedScript) {
      this.localRule.properties.conditionScript = updatedScript;
      this.$emit('update:rule', cloneDeep(this.localRule));
    },
    evaluateConditionScript() {
      const scriptToEval = `module.exports = () => {
        ${this.localRule.properties.conditionScript}
      }`;
      return ApiService.evaluateScript({
        script: scriptToEval,
        scriptParams: get(this.localRule, 'properties.stateMetrics', []).map(() => 42)
      });
    }
  }
};